/* About / Our Story — scroll reveal (progressive enhancement).
   Initial hidden state is applied via CSS keyed on <html class="ar-ready">,
   which is set synchronously in <head> to avoid any flash of content. */
(function () {
  if (!('IntersectionObserver' in window)) {
    document.documentElement.classList.remove('ar-ready');
    return;
  }
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  function init() {
    var targets = document.querySelectorAll(
      '.template-page .image-text-section__image,' +
      '.template-page .image-text-section__text-inner,' +
      '.template-page .video-section__video-wrapper'
    );
    if (!targets.length) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('ar-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    targets.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
